























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {}
})
export default class AppFooter extends Vue {

    get helpContacts() {
        if (this.$store.state.data)
            return this.$store.state.data.base_info.help_contacts
        else return [];
    }

    get latestGoal() {
      if (this.$store.state.data) {
        if (this.$store.state.data.goals && this.$store.state.data.goals.length) {
          return this.$store.state.data.goals[0].goalKey
        }
        return 'latest';
      }
      return 'latest';
    }

    get shouldDisplayBooklets() {
        if (this.$store.state.data) {
            if (this.$store.state.data.goals && this.$store.state.data.goals.length) {
              if (this.$store.state.data.goals[0].details &&
                      this.$store.state.data.goals[0].details.promptGoalBooklets &&
                      this.$store.state.data.goals[0].details.promptGoalBooklets.length) {
                return true;
              }
              return false;
            }
            return false;
        }
        return false;
    }

}
